import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */

import React, { useRef, useState } from 'react';
import { Form } from 'semantic-ui-react';
import { PHONE_NUMBER_PLACEHOLDER } from './PhoneNumberField.constants';
import PhoneInput from '../../PhoneInput';
var defaultProps = {
  name: 'phoneNumber',
  defaultValue: '',
  onChange: null,
  value: undefined,
  required: false
};
function PhoneNumberField(_ref) {
  var name = _ref.name,
    defaultValue = _ref.defaultValue,
    onChange = _ref.onChange,
    value = _ref.value,
    required = _ref.required;
  var _useRef = useRef(value !== undefined),
    isControlled = _useRef.current;
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    phoneNumberState = _useState2[0],
    setPhoneNumberState = _useState2[1];
  var valueDerived = isControlled ? value : phoneNumberState;
  function handleOnChange(e, target) {
    var phoneNumber = target.value;
    if (!isControlled) {
      setPhoneNumberState(phoneNumber);
    }
    if (onChange) {
      onChange(e, target);
    }
  }
  return /*#__PURE__*/React.createElement(Form.Field, {
    required: required
  }, /*#__PURE__*/React.createElement("label", null, "Phone Number"), /*#__PURE__*/React.createElement(PhoneInput, {
    value: valueDerived,
    name: name,
    placeholder: PHONE_NUMBER_PLACEHOLDER,
    onChange: handleOnChange,
    required: required
  }));
}
PhoneNumberField.defaultProps = defaultProps;
export default PhoneNumberField;